import React from "react";
import { connect } from "react-redux";

function NoDataFoundTrow(props) {
  let { colspan, classes, text } = props;
  return (
    <tr>
      <td colSpan={colspan ? colspan : 1} className={classes ? classes : ""}>
        <br />
        <br />
        {text ? text : null}
        <br />
        <br />
        <br />
      </td>
    </tr>
  );
}

const mapStateToProps = (state) => {
  return {
    session: state.session,
  };
};

export default connect(mapStateToProps)(NoDataFoundTrow);
